import { render, staticRenderFns } from "./CollectionForm.vue?vue&type=template&id=8fe0a9e6&scoped=true&"
import script from "./CollectionForm.vue?vue&type=script&lang=js&"
export * from "./CollectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe0a9e6",
  null
  
)

export default component.exports